module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-creative-intro-card1.2.80f55d2e.jpg";